import { Link } from "react-router-dom";

const CreativeAgencyTwoPrice = () => {
  return (
    <>
      <div className="ca-two-price-area ptb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <div className="text-center">
                <h2 className="ca-two-title ca-two-body-clr-two fs-36 fw-500 flh-48 pr-20">
                  Affordable Excellence Agency Pricing that Works
                </h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xxl-10">
              <div className="ca-two-price-items mt-20">
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6">
                    <div className="ca-two-price-item text-center ca-two-bg-five pt-60 pb-30 pl-40 pr-40 rounded-16 mt-20 position-relative">
                      <h6 className="ca-two-pf-cet ca-two-subtitle ca-two-body-clr ff-dmsans d-flex bg-white align-items-center mb-0 position-absolute z-2">
                        <span className="ca-two-bg-four"></span>Starter Plan
                      </h6>
                      <h5 className="ca-two-price text-black fw-600 fs-48">
                        $30 <span className="fs-16">/ Month</span>
                      </h5>
                      <p className="ca-two-body-clr flh-24 mt-20 mb-0">
                        Use Code: STARTER1 at checkout
                      </p>
                      <Link
                        href="/services"
                        className="btn dg-outline-btn ca-two-body-clr ca-two-bg-hover mt-30 w-100"
                      >
                        Get in Touch
                      </Link>
                      <ul className="ca-two-price-list list-unstyled text-start d-flex flex-column gap-2 mt-30">
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Get answers in real-time
                        </li>
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Report on what matter
                        </li>
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Collaborate seamlessly
                        </li>
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Collaborate seamlessly
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="ca-two-price-item text-center ca-two-bg-five pt-60 pb-30 pl-40 pr-40 rounded-16 mt-20 position-relative">
                      <h6 className="ca-two-pf-cet ca-two-subtitle ca-two-body-clr ff-dmsans d-flex bg-white align-items-center mb-0 position-absolute z-2">
                        <span className="ca-two-bg-four"></span>Starter Plan
                      </h6>
                      <h5 className="ca-two-price text-black fw-600 fs-48">
                        $54 <span className="fs-16">/ Month</span>
                      </h5>
                      <p className="ca-two-body-clr flh-24 mt-20 mb-0">
                        Use Code: STARTER1 at checkout
                      </p>
                      <Link
                        href="/services"
                        className="btn dg-outline-btn ca-two-body-clr ca-two-bg-hover mt-30 w-100"
                      >
                        Get in Touch
                      </Link>
                      <ul className="ca-two-price-list list-unstyled text-start d-flex flex-column gap-2 mt-30">
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Get answers in real-time
                        </li>
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Report on what matter
                        </li>
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Collaborate seamlessly
                        </li>
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Collaborate seamlessly
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="ca-two-price-item text-center ca-two-bg-five pt-60 pb-30 pl-40 pr-40 rounded-16 mt-20 position-relative">
                      <h6 className="ca-two-pf-cet ca-two-subtitle ca-two-body-clr ff-dmsans d-flex bg-white align-items-center mb-0 position-absolute z-2">
                        <span className="ca-two-bg-four"></span>Starter Plan
                      </h6>
                      <h5 className="ca-two-price text-black fw-600 fs-48">
                        $99 <span className="fs-16">/ Yearly</span>
                      </h5>
                      <p className="ca-two-body-clr flh-24 mt-20 mb-0">
                        Use Code: STARTER1 at checkout
                      </p>
                      <Link
                        href="/services"
                        className="btn dg-outline-btn ca-two-body-clr ca-two-bg-hover mt-30 w-100"
                      >
                        Get in Touch
                      </Link>
                      <ul className="ca-two-price-list list-unstyled text-start d-flex flex-column gap-2 mt-30">
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Get answers in real-time
                        </li>
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Report on what matter
                        </li>
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Collaborate seamlessly
                        </li>
                        <li className="ca-two-body-clr fs-16 d-flex align-items-center gap-3">
                          <span className="ca-two-body-clr fs-12 ca-two-border-two ca-two-border-color-two rounded-circle">
                            <i className="fa-solid fa-check"></i>
                          </span>
                          Collaborate seamlessly
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyTwoPrice;
